import createEmotion, { type Emotion } from 'create-emotion';

export const emotionInstance: Emotion = createEmotion({ key: 'ui-kit-css' });
